import React from 'react';
import clsx from 'clsx';
import { CheckboxInput } from '@td-client-frontend/common';
import ComponentWrapperRHF from './ComponentWrapperRHF';

interface Props {
  name: string;
  label?: string;
  className?: string;
}

export const CheckboxRhf = ({ className, ...props }: Props) => {
  return (
    <div className={clsx('flex gap-2', className)}>
      <ComponentWrapperRHF {...props}>
        <CheckboxInput colorType="blue" />
      </ComponentWrapperRHF>
      {props.label && <div>{props.label}</div>}
    </div>
  );
};
